import React, { useContext, useEffect, useMemo } from "react";
import { Form, Select, Input, Button, Radio } from "antd";
import { CLINIC_DOCTOR_FLAG } from "modules/utilities/utility";
import { get } from "lodash";
import { prescriptionContext } from "./MedicineContext";

function InternalTrayaPrescription({
  prescriptionStoreTraya,
  setPrescriptionStoreTraya,
  medicineTraya,
  setMedicineTraya,
  setMonthSelection = () => {},
  allopathyProduct,
  mappedComment
}) {

  const monthData = useContext(prescriptionContext);
  const month = ["1 Month", "3 Month", "5 Month"];

  useEffect(() => {
    if (medicineTraya.prescription) {
      const selectedComment = get(
        mappedComment,
        `[${medicineTraya.prescription}][0].comment`,
        ""
      );
      const selectedDosage = get( mappedComment, `[${medicineTraya.prescription}][0].dosage`, "");
      setMedicineTraya((prev) => ({
        ...prev,
        comment: selectedComment,
        dosage: selectedDosage,
      }));
    }
  }, [medicineTraya.prescription, mappedComment, setMedicineTraya]);

  const handleMedicineChange = (index, event, select = false) => {
    let name, value;
    if (select) {
      name = "prescription";
      value = event;
    } else {
      ({ name, value } = event.target);
    }
    const updatedMedicines = prescriptionStoreTraya.map((item, idx) =>
      idx === index ? { ...item, [name]: value } : item
    );
    setPrescriptionStoreTraya(updatedMedicines);
  };

  const handleAddMedicine = () => {
    setPrescriptionStoreTraya([
      ...prescriptionStoreTraya,
      { ...medicineTraya },
    ]);
    if (CLINIC_DOCTOR_FLAG) {
      setMedicineTraya({
        prescription: "",
        dosage: "",
        comment: "",
        quantity: "",
      });
    } else {
      setMedicineTraya({
        prescription: "",
        dosage: "",
        comment: "",
      });
    }
  };

  const handleRemoveMedicine = (index) => {
    const updatedMedicines = prescriptionStoreTraya.filter(
      (_, idx) => idx !== index
    );
    setPrescriptionStoreTraya(updatedMedicines);
  };

  const renderMedicineInputs = () => {
    return prescriptionStoreTraya.map((item, index) => (
      <div key={index} className="d-flex justify-content-between gap-2">
        <Form.Item
          key={`prescription-${index}`}
          className="mb-3 flex-1"
          style={{ minWidth: "30%" }}
        >
          <Select
            name="prescription"
            value={item?.prescription}
            onChange={(value) => handleMedicineChange(index, value, true)}
            placeholder={
              item?.prescription.charAt(0).toUpperCase() +
              item?.prescription.slice(1)
            }
            showSearch
          >
            <Select.Option value="">Select Allopath Doctor</Select.Option>
            {allopathyProduct?.map((product) => (
              <Select.Option key={product.label} value={product.label}>
                {product.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          key="initial-dosage"
          className="mb-3 flex-1"
          style={{ minWidth: "20%" }}
        >
          <Input
            name="dosage"
            value={item.dosage}
            onChange={(e) => handleMedicineChange(index, e)}
            placeholder="Dosage"
          />
        </Form.Item>
        <Form.Item
          key="initial-comment"
          className="mb-3 flex-1"
          style={{ minWidth: "20%" }}
        >
          <Input
            name="comment"
            value={item.comment}
            onChange={(e) => handleMedicineChange(index, e)}
            placeholder="Comment"
          />
        </Form.Item>

        { CLINIC_DOCTOR_FLAG && (
          <Form.Item
            key={`quantity-${index}`}
            className="mb-3"
            style={{ minWidth: "20%" }}
          >
            <Input
              name="quantity"
              value={item.quantity}
              onChange={(e) => handleMedicineChange(index, e)}
              placeholder="Quantity"
            />
          </Form.Item>
        )}
        <Button
          type="danger"
          size="small"
          onClick={(event) => {
            event.preventDefault();
            handleRemoveMedicine(index);
          }}
        >
          -
        </Button>
      </div>
    ));
  };

  return (
    <div>
      {CLINIC_DOCTOR_FLAG && (
        <div className="mt-n4 my-3">
          <Radio.Group
            onChange={(event) => setMonthSelection(event.target.value)}
            name="monthRadioGroup"
          >
            {month?.map((item) => (
              <Radio key={item} value={item}>
                {item}
              </Radio>
            ))}
          </Radio.Group>
        </div>
      )}
      <Form>
        {renderMedicineInputs()}
        <div className="d-flex justify-content-between gap-2 w-full">
          <Form.Item
            key={`${allopathyProduct?.prescription}`}
            className="mb-3 flex-1"
            style={{ minWidth: "30%" }}
          >
            <Select
              name="prescription"
              className="flex-1"
              value={medicineTraya?.prescription}
              onChange={(value) => {
                if (value === "Minoxidil Tablet 3X10") {
                  if (monthData) {
                    setMedicineTraya({
                      ...medicineTraya,
                      prescription: value,
                      productId: "43924864598194",
                      month: monthData,
                    });
                  }
                } else {
                  setMedicineTraya({
                    ...medicineTraya,
                    prescription: value,
                  });
                }
              }}
              placeholder={
                medicineTraya?.prescription.charAt(0).toUpperCase() +
                medicineTraya?.prescription.slice(1)
              }
              showSearch
            >
              <Select.Option value="">Select Allopath Medicine</Select.Option>
              {allopathyProduct?.map((product, index) => (
                <Select.Option
                  key={`${product.label}-${index}`}
                  value={product.label}
                >
                  {product.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            key="initial-dosage"
            className="mb-3 flex-1"
            style={{ minWidth: "20%" }}
          >
            <Input
              name="dosage"
              value={ medicineTraya["dosage"] }
              onChange={(e) =>
                setMedicineTraya({
                  ...medicineTraya,
                  dosage: e.target.value,
                })
              }
              placeholder="Dosage"
            />
          </Form.Item>
          <Form.Item
            key="initial-comment"
            className="mb-3 flex-1"
            style={{ minWidth: "20%" }}
          >
            <Input
              name="comment"
              value={ medicineTraya["comment"] }
              onChange={(e) => {
                setMedicineTraya({
                  ...medicineTraya,
                  comment: e.target.value
                });
              }}
              placeholder="Comment"
            />
          </Form.Item>

          {CLINIC_DOCTOR_FLAG && (
            <Form.Item
              key="initial-quantity"
              className="mb-3"
              style={{ minWidth: "20%" }}
            >
              <Input
                name="quantity"
                value={medicineTraya.quantity}
                onChange={(e) =>
                  setMedicineTraya({
                    ...medicineTraya,
                    quantity: e.target.value,
                  })
                }
                type="number"
                placeholder="Quantity"
              />
            </Form.Item>
          )}
          <Button type="primary" size="small" onClick={handleAddMedicine}>
            +
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default InternalTrayaPrescription;
